export const checkoutPalette = {
    primary: '#060809',
    secondary: '#FFFFFF',
    accent: '#F08A5D',
    support: '#5E807F',
    supportDark: '#082D0F',
    success: '#00E676',
    info: '#2F80ED',
    warning: '#FFC107',
    danger: '#F44336',
    pageGradient: 'radial-gradient(circle at top, rgba(94,128,127,0.28) 0%, #060809 52%)',
    panelGradient: 'linear-gradient(180deg, rgba(12,16,18,0.98) 0%, #060809 100%)',
    accentGradient: 'linear-gradient(135deg, #F08A5D 0%, #5E807F 100%)',
    heroGradient: 'linear-gradient(135deg, rgba(240,138,93,0.18) 0%, rgba(94,128,127,0.24) 45%, rgba(6,8,9,0.96) 100%)',
    panelSurface: 'rgba(9,13,14,0.92)',
    panelSurfaceStrong: 'rgba(6,8,9,0.96)',
    glassSurface: 'rgba(9,13,14,0.82)',
    border: 'rgba(255,255,255,0.08)',
    borderStrong: 'rgba(255,255,255,0.16)',
    textMuted: 'rgba(255,255,255,0.72)',
    textSoft: 'rgba(255,255,255,0.62)',
    chipSurface: 'rgba(255,255,255,0.08)',
    accentSurface: 'rgba(240,138,93,0.16)',
    successSurface: 'rgba(0,230,118,0.12)',
};
